import React, { useState } from 'react';
import { FiCheckCircle, FiBarChart2, FiCpu, FiShield, FiZap, FiGlobe, FiActivity, FiDatabase, FiLock, FiDroplet, FiTarget, FiAward, FiCheck } from 'react-icons/fi';
import logoCF2 from '../assets/CF2.svg';

const ProductPage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const features = [
    {
      icon: <FiZap />,
      title: 'Высокая удельная активность',
      description: '3 183 у.е./мг — в 2,8–4,8 раза выше, чем у импортного рекомбинантного коагулянта (667–1 122 у.е./мг)',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      icon: <FiTarget />,
      title: 'Дешёвое сырьё',
      description: 'Пермеат молочной сыворотки и кукурузный экстракт — отходы производства',
      gradient: 'from-green-500 to-emerald-500'
    },
    {
      icon: <FiAward />,
      title: 'Продуцент — GRAS',
      description: 'Дрожжи Kluyveromyces lactis со статусом GRAS (FDA)',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      icon: <FiDroplet />,
      title: 'Очистка без хроматографии',
      description: 'Только ультрафильтрация и диафильтрация — проще и дешевле',
      gradient: 'from-orange-500 to-red-500'
    }
  ];

  const experimentalData = [
    {
      title: 'Штамм-продуцент создан',
      items: [
        'Получен рекомбинантный штамм K. lactis',
        'Налажено воспроизводимое культивирование'
      ]
    },
    {
      title: 'Процесс оптимизирован',
      items: [
        'Активность 1 774 у.е./мл при цикле 5 суток вместо 7',
        'Удельная продуктивность выросла на 66%'
      ]
    },
    {
      title: 'Отнесен к высококачественному (универсальному) коагулянту',
      items: [
        'Превосходит коровий фермент по протеолитической активности',
        'Соответствует требованиям к pH, термостабильности и чувствительности к Ca²⁺'
      ]
    },
    {
      title: 'Проверено на сыре в СибНИИ сыроделия ФГБНУ ФАНЦА, г. Барнаул',
      items: [
        'Полутвердый сыр со сроком созревания 1,5 месяца',
        'Органолептика с высокими оценками согласно ГОСТ 33630-2015',
        'Выход по ТУ «Плеяр»'
      ]
    }
  ];

  const comparisonData = [
    {
      parameter: 'Тип фермента',
      ourProduct: 'рекомбинантный',
      chyMaxSupreme: 'рекомбинантный',
      animal: 'экстракт из сычугов'
    },
    {
      parameter: 'Удельная активность по массе белка, у.е./мг',
      ourProduct: '3 183',
      chyMaxSupreme: '667–1 122',
      animal: 'нет данных'
    },
    {
      parameter: 'Очистка',
      ourProduct: 'только УФ',
      chyMaxSupreme: 'хроматография + УФ',
      animal: 'экстракция'
    },
    {
      parameter: 'Доступность в РФ',
      ourProduct: 'локально',
      chyMaxSupreme: 'импорт',
      animal: 'ограничена сырьём'
    },
    {
      parameter: 'Продуцент',
      ourProduct: 'Kluyveromyces lactis',
      chyMaxSupreme: 'Aspergillus niger',
      animal: 'сычуг телёнка'
    }
  ];

  const tabs = [
    { id: 'overview', label: 'Обзор' },
    { id: 'features', label: 'Преимущества' },
    { id: 'comparison', label: 'Сравнение с конкурентами' }
  ];

  return (
    <div className="product-page">
      {/* Animated Background */}
      <div className="product-bg">
        <div className="bg-grid"></div>
        <div className="floating-orbs">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="product-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="product-badge">
                <span className="badge-icon">🧀</span>
                <span className="badge-text">ОПЫТНЫЙ ОБРАЗЕЦ · ПИЛОТНЫЕ ВАРКИ 2026</span>
              </div>
              
              <h1 className="hero-title">
                <span>Сыролёт —</span>
                <span className="gradient-text">российский рекомбинантный химозин</span>
              </h1>
              
              
            </div>
            
            <div className="hero-stats">
              <div className="stat">
                <div className="stat-value">3183</div>
                <div className="stat-label">у.е./мг активность</div>
              </div>
              <div className="stat">
                <div className="stat-value">1 774±90</div>
                <div className="stat-label">у.е./мл культуральной жидкости</div>
              </div>
              <div className="stat">
                <div className="stat-value">>96%</div>
                <div className="stat-label">импортозависимость РФ</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs Navigation */}
      <section className="tabs-section">
        <div className="container">
          <div className="tabs-nav">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Tab Content */}
      <section className="tab-content-section">
        <div className="container">
          {activeTab === 'overview' && (
            <div className="tab-content">
              <div className="overview-grid">
                <div className="overview-card">
                  <div className="card-icon">
                    <FiActivity />
                  </div>
                  <h3>Высокая активность</h3>
                  <p>
                    Удельная активность 3 183 у.е./мг — в 2,8–4,8 раза выше, чем у импортного 
                    рекомбинантного коагулянта (667–1 122 у.е./мг).
                  </p>
                </div>
                
                <div className="overview-card">
                  <div className="card-icon">
                    <FiDatabase />
                  </div>
                  <h3>Технология производства</h3>
                  <p>
                    Используем продуцент Kluyveromyces lactis с GRAS статусом. 
                    Очистка методом ультрафильтрации и диафильтрации — проще и дешевле хроматографии.
                  </p>
                </div>
                
                <div className="overview-card">
                  <div className="card-icon">
                    <FiDroplet />
                  </div>
                  <h3>Дешёвое сырьё</h3>
                  <p>
                    Молочная сыворотка и кукурузный экстракт — отходы производства, 
                    что значительно снижает себестоимость фермента.
                  </p>
                </div>
              </div>

              {/* CF2 Image */}
              <div className="cf2-section">
                <img 
                  src={logoCF2} 
                  alt="Сыролёт иллюстрация" 
                  className="cf2-image"
                  style={{
                    width: '300px',
                    height: '130px',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                    background: 'transparent',
                  }}
                />
              </div>

              {/* Экспериментальные данные */}
              <div className="experimental-section">
                <h3 className="experimental-title">
                  <FiCheckCircle className="experimental-title-icon" />
                  Что уже подтверждено экспериментально
                </h3>
                <div className="experimental-grid">
                  {experimentalData.map((item, index) => (
                    <div key={index} className="experimental-card">
                      <h4 className="experimental-card-title">{item.title}</h4>
                      <ul className="experimental-list">
                        {item.items.map((subItem, subIndex) => (
                          <li key={subIndex} className="experimental-item">
                            <FiCheck className="experimental-check" />
                            <span>{subItem}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'features' && (
            <div className="tab-content">
              <div className="features-grid">
                {features.map((feature, index) => (
                  <div key={index} className="feature-card">
                    <div className="feature-icon-wrapper">
                      <div className="icon-backdrop"></div>
                      <div className="feature-icon">{feature.icon}</div>
                    </div>
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                    <div className="feature-benefit">
                      {index === 0 && 'Превосходство над конкурентами по ключевому показателю'}
                      {index === 1 && 'Снижение себестоимости производства'}
                      {index === 2 && 'Безопасный продуцент для пищевой промышленности'}
                      {index === 3 && 'Упрощение и удешевление технологического процесса'}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'comparison' && (
            <div className="tab-content">
              <div className="comparison-header">
                <h3>Сравнение с доступными коагулянтами</h3>
                <p className="comparison-subtitle">
                  Как наш образец соотносится с импортным рекомбинантным и животным сычужным ферментом
                </p>
                <p className="comparison-note">
                  Данные по удельной активности приведены на массу белка. Показатели конкурентов — по данным производителей.
                </p>
              </div>

              {/* Таблица сравнения */}
              <div className="comparison-table-wrapper">
                <table className="comparison-table">
                  <thead>
                    <tr>
                      <th>Параметр</th>
                      <th className="highlight-col">Сыролёт</th>
                      <th>Chr. Hansen</th>
                      <th>Сычужный животный (РФ)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comparisonData.map((row, index) => (
                      <tr key={index}>
                        <td className="param-label">{row.parameter}</td>
                        <td className="highlight-col our-value">{row.ourProduct}</td>
                        <td>{row.chyMaxSupreme}</td>
                        <td>{row.animal}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Дополнительная информация */}
              <div className="comparison-info">
                <div className="info-card">
                  <h4>Ключевые преимущества Сыролёта</h4>
                  <div className="info-grid">
                    <div className="info-item">
                      <span className="info-label">Продуцент:</span>
                      <span className="info-value highlight">Kluyveromyces lactis</span>
                      <span className="info-note">статус GRAS (FDA)</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Очистка:</span>
                      <span className="info-value highlight">Ультрафильтрация + диафильтрация</span>
                      <span className="info-note">без хроматографии</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Сырьё:</span>
                      <span className="info-value highlight">Отходы производства</span>
                      <span className="info-note">молочная сыворотка, кукурузный экстракт</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Доступность:</span>
                      <span className="info-value highlight">Локальное производство</span>
                      <span className="info-note">импортозамещение</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="product-cta">
        <div className="container">
          <div className="cta-card">
            <div className="cta-content">
              <h2>Мы вас заинтересовали и вы готовы сотрудничать?</h2>
              <p>
                Получите подробную консультацию и информацию о технических характеристиках. 
                Свяжитесь с нами!
              </p>
              <a href="/contacts" className="btn btn-primary">
                Заказать обратную связь
              </a>
            </div>
            <div className="cta-visual">
              <div className="cheese-wheel"></div>
            </div>
          </div>
        </div>
      </section>

      <style jsx="true">{`
        .product-page {
          position: relative;
          overflow-x: hidden;
        }

        /* Background */
        .product-bg {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: -1;
        }

        .bg-grid {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: 
            linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
          background-size: 50px 50px;
          opacity: 0.05;
        }

        .floating-orbs {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(60px);
          opacity: 0.1;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          background: #3B82F6;
          top: 20%;
          left: 10%;
          animation: float 8s ease-in-out infinite;
        }

        .orb-2 {
          width: 400px;
          height: 400px;
          background: #8B5CF6;
          bottom: 20%;
          right: 10%;
          animation: float 10s ease-in-out infinite reverse;
        }

        .orb-3 {
          width: 200px;
          height: 200px;
          background: #10B981;
          top: 50%;
          left: 80%;
          animation: float 6s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }

        /* Hero Section */
        .product-hero {
          padding: 100px 0 60px;
          position: relative;
        }

        .hero-content {
          text-align: center;
          max-width: 800px;
          margin: 0 auto;
        }

        .product-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: rgba(59, 130, 246, 0.1);
          border: 1px solid rgba(59, 130, 246, 0.3);
          border-radius: 20px;
          margin-bottom: 30px;
          backdrop-filter: blur(10px);
          animation: pulse 2s infinite;
        }

        .badge-icon {
          font-size: 1.2rem;
        }

        .badge-text {
          font-size: 0.875rem;
          font-weight: 500;
          color: #3B82F6;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .hero-title {
          font-size: 3.5rem;
          margin-bottom: 20px;
          line-height: 1.1;
        }

        .gradient-text {
          background: linear-gradient(135deg, #3B82F6, #8B5CF6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          display: block;
        }

        .hero-description {
          font-size: 1.125rem;
          color: #CBD5E1;
          margin-bottom: 40px;
          line-height: 1.6;
        }

        .hero-stats {
          display: flex;
          justify-content: center;
          gap: 40px;
          flex-wrap: wrap;
        }

        .stat {
          text-align: center;
        }

        .stat-value {
          font-size: 2.5rem;
          font-weight: 700;
          color: #3B82F6;
          margin-bottom: 5px;
        }

        .stat-label {
          font-size: 0.875rem;
          color: #CBD5E1;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* Tabs */
        .tabs-section {
          position: sticky;
          top: 80px;
          z-index: 100;
          background: rgba(15, 23, 42, 0.95);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          padding: 0;
        }

        .tabs-nav {
          display: flex;
          overflow-x: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .tabs-nav::-webkit-scrollbar {
          display: none;
        }

        .tab-btn {
          flex: 1;
          min-width: 120px;
          padding: 20px 0;
          background: none;
          border: none;
          color: #CBD5E1;
          font-size: 1rem;
          font-weight: 500;
          cursor: pointer;
          position: relative;
          transition: all 0.3s ease;
          border-bottom: 3px solid transparent;
        }

        .tab-btn:hover {
          color: #FFFFFF;
        }

        .tab-btn.active {
          color: #3B82F6;
          border-bottom-color: #3B82F6;
        }

        .tab-btn.active::before {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, #3B82F6, #8B5CF6);
          opacity: 0.5;
        }

        /* Tab Content */
        .tab-content-section {
          padding: 60px 0;
        }

        .tab-content {
          animation: fadeIn 0.5s ease-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Overview Grid */
        .overview-grid {
          display: grid;
          gap: 30px;
        }

        @media (min-width: 768px) {
          .overview-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        .overview-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 40px;
          text-align: center;
          transition: all 0.3s ease;
        }

        .overview-card:hover {
          transform: translateY(-5px);
          border-color: #3B82F6;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
        }

        .card-icon {
          width: 60px;
          height: 60px;
          background: rgba(59, 130, 246, 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          color: #3B82F6;
          font-size: 1.5rem;
        }

        .overview-card h3 {
          margin-bottom: 15px;
          color: #FFFFFF;
        }

        .overview-card p {
          color: #CBD5E1;
          margin: 0;
          line-height: 1.6;
        }

        /* CF2 Image Section */
        .cf2-section {
          margin: 60px 0;
          text-align: center;
        }

        .cf2-image {
          max-width: 100%;
          height: auto;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        /* Experimental Section */
        .experimental-section {
          margin-top: 20px;
        }

        .experimental-title {
          text-align: center;
          font-size: 2rem;
          color: #FFFFFF;
          margin-bottom: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .experimental-title-icon {
          color: #10B981;
          font-size: 2rem;
        }

        .experimental-grid {
          display: grid;
          gap: 20px;
        }

        @media (min-width: 768px) {
          .experimental-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        .experimental-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 25px;
          transition: all 0.3s ease;
          height: 100%;
        }

        .experimental-card:hover {
          transform: translateY(-5px);
          border-color: #10B981;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        .experimental-card-title {
          color: #FFFFFF;
          font-size: 1rem;
          margin-bottom: 15px;
          padding-bottom: 12px;
          border-bottom: 2px solid rgba(16, 185, 129, 0.3);
          line-height: 1.4;
          word-wrap: break-word;
        }

        .experimental-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .experimental-item {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: #CBD5E1;
          font-size: 0.875rem;
          line-height: 1.5;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }

        .experimental-check {
          color: #10B981;
          font-size: 1rem;
          flex-shrink: 0;
          margin-top: 3px;
        }

        /* Features Grid */
        .features-grid {
          display: grid;
          gap: 20px;
        }

        @media (min-width: 768px) {
          .features-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .features-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        .feature-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 20px;
          transition: all 0.3s ease;
          text-align: center;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .feature-card:hover {
          transform: translateY(-5px);
          border-color: #3B82F6;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        .feature-icon-wrapper {
          position: relative;
          width: 80px;
          height: 80px;
          margin: 0 auto 20px;
        }

        .icon-backdrop {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #3B82F6, #8B5CF6);
          border-radius: 50%;
          opacity: 0.1;
          animation: pulse 3s infinite;
        }

        .feature-icon {
          position: relative;
          width: 100%;
          height: 100%;
          background: rgba(30, 41, 59, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: #3B82F6;
          border: 2px solid rgba(255, 255, 255, 0.1);
        }

        .feature-title {
          font-size: 1.25rem;
          margin-bottom: 10px;
          color: #FFFFFF;
        }

        .feature-description {
          color: #CBD5E1;
          margin-bottom: 15px;
          font-size: 0.875rem;
          line-height: 1.5;
        }

        .feature-benefit {
          display: inline-block;
          padding: 8px 12px;
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.2);
          border-radius: 20px;
          color: #10B981;
          font-size: 0.75rem;
          font-weight: 500;
          line-height: 1.4;
          word-wrap: break-word;
          overflow-wrap: break-word;
          max-width: 100%;
          margin-top: auto;
        }

        /* Comparison Table */
        .comparison-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .comparison-header h3 {
          font-size: 2rem;
          margin-bottom: 10px;
          color: #FFFFFF;
        }

        .comparison-subtitle {
          color: #CBD5E1;
          max-width: 600px;
          margin: 0 auto 10px;
          line-height: 1.5;
        }

        .comparison-note {
          color: #94A3B8;
          font-size: 0.85rem;
          font-style: italic;
          max-width: 600px;
          margin: 0 auto;
        }

        .comparison-table-wrapper {
          overflow-x: auto;
          margin-bottom: 40px;
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 4px;
        }

        .comparison-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.95rem;
          min-width: 600px;
        }

        .comparison-table thead {
          background: rgba(59, 130, 246, 0.15);
        }

        .comparison-table th {
          padding: 16px 20px;
          text-align: left;
          color: #FFFFFF;
          font-weight: 600;
          border-bottom: 2px solid rgba(255, 255, 255, 0.1);
        }

        .comparison-table th.highlight-col {
          background: rgba(255, 215, 0, 0.15);
          color: #FFD700;
        }

        .comparison-table td {
          padding: 14px 20px;
          color: #CBD5E1;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }

        .comparison-table tbody tr:hover {
          background: rgba(255, 255, 255, 0.03);
        }

        .comparison-table tbody tr:last-child td {
          border-bottom: none;
        }

        .comparison-table .param-label {
          font-weight: 500;
          color: #94A3B8;
          white-space: nowrap;
        }

        .comparison-table .highlight-col {
          background: rgba(255, 215, 0, 0.08);
        }

        .comparison-table .our-value {
          color: #FFD700;
          font-weight: 600;
        }

        /* Comparison Info */
        .comparison-info {
          margin-top: 40px;
        }

        .info-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 30px;
        }

        .info-card h4 {
          color: #FFFFFF;
          margin-bottom: 20px;
          text-align: center;
        }

        .info-grid {
          display: grid;
          gap: 20px;
        }

        @media (min-width: 768px) {
          .info-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .info-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        .info-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 8px;
        }

        .info-label {
          color: #CBD5E1;
          font-size: 0.875rem;
        }

        .info-value {
          color: #FFFFFF;
          font-weight: 600;
          font-size: 1rem;
        }

        .info-value.highlight {
          color: #FFD700;
        }

        .info-note {
          color: #64748B;
          font-size: 0.75rem;
        }

        /* CTA Section */
        .product-cta {
          padding: 80px 0;
        }

        .cta-card {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 24px;
          padding: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .cta-content {
          position: relative;
          z-index: 1;
          max-width: 600px;
        }

        .cta-content h2 {
          font-size: 2.5rem;
          margin-bottom: 20px;
        }

        .cta-content p {
          color: #CBD5E1;
          margin-bottom: 30px;
          font-size: 1.125rem;
          line-height: 1.6;
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 24px;
          background: #3B82F6;
          color: white;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          background: #2563EB;
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(59, 130, 246, 0.3);
        }

        .cta-visual {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
        }

        .cheese-wheel {
          position: absolute;
          right: -50px;
          bottom: -50px;
          width: 200px;
          height: 200px;
          background: conic-gradient(from 0deg, 
            #FFD700 0%, #FFA500 25%, 
            #FF8C00 50%, #FFD700 75%, 
            #FFA500 100%);
          border-radius: 50%;
          animation: rotate 20s linear infinite;
          opacity: 0.3;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Mobile Responsive */
        @media (max-width: 767px) {
          .hero-title {
            font-size: 2rem;
          }

          .hero-stats {
            gap: 15px;
          }

          .stat-value {
            font-size: 1.5rem;
          }

          .stat-label {
            font-size: 0.75rem;
          }

          .overview-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }

          .overview-card {
            padding: 20px;
          }

          .features-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }

          .feature-card {
            padding: 15px;
          }

          .feature-icon-wrapper {
            width: 60px;
            height: 60px;
          }

          .feature-icon {
            font-size: 1.5rem;
          }

          .feature-title {
            font-size: 1.1rem;
          }

          .feature-description {
            font-size: 0.8rem;
          }

          .feature-benefit {
            font-size: 0.7rem;
            padding: 6px 10px;
          }

          .experimental-title {
            font-size: 1.5rem;
          }

          .experimental-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }

          .experimental-card {
            padding: 15px;
          }

          .experimental-card-title {
            font-size: 0.9rem;
          }

          .experimental-item {
            font-size: 0.8rem;
          }

          .cf2-section {
            margin: 30px 0;
          }

          .comparison-table {
            font-size: 0.8rem;
            min-width: 480px;
          }

          .comparison-table th,
          .comparison-table td {
            padding: 10px 12px;
          }

          .comparison-header h3 {
            font-size: 1.5rem;
          }

          .info-grid {
            grid-template-columns: 1fr 1fr;
          }

          .cta-card {
            padding: 30px 15px;
          }

          .cta-content h2 {
            font-size: 1.5rem;
          }
        }

        /* Tablet Responsive */
        @media (min-width: 768px) and (max-width: 1024px) {
          .container {
            max-width: 900px;
            padding-left: 20px;
            padding-right: 20px;
          }

          .hero-title {
            font-size: 2.5rem;
          }

          .features-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }

          .feature-card {
            padding: 20px;
          }

          .experimental-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }

          .experimental-card {
            padding: 20px;
          }

          .cf2-section {
            margin: 40px 0;
          }

          .comparison-table {
            font-size: 0.85rem;
          }

          .info-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 480px) {
          .container {
            padding-left: 12px;
            padding-right: 12px;
          }

          .hero-title {
            font-size: 1.8rem;
          }

          .hero-stats {
            gap: 10px;
          }

          .stat {
            flex: 1;
            min-width: 80px;
          }

          .stat-value {
            font-size: 1.2rem;
          }

          .stat-label {
            font-size: 0.65rem;
          }

          .comparison-table {
            font-size: 0.7rem;
            min-width: 380px;
          }

          .comparison-table th,
          .comparison-table td {
            padding: 8px 8px;
          }

          .comparison-header h3 {
            font-size: 1.3rem;
          }

          .comparison-subtitle {
            font-size: 0.85rem;
          }

          .comparison-note {
            font-size: 0.75rem;
          }

          .info-grid {
            grid-template-columns: 1fr;
          }

          .info-item {
            padding: 8px 0;
          }

          .cta-card {
            padding: 20px 12px;
          }

          .cta-content h2 {
            font-size: 1.2rem;
          }

          .cta-content p {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductPage;
